/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, updateDoc, setDoc } from 'firebase/firestore';
import { GENEROS_LIBROS } from './constants';

// ── Ilustración 1: Bienvenida — libros flotando con glow ─────────────────────
const IlusBienvenida = () => (
  <svg viewBox="0 0 320 260" style={{ width: '100%', maxWidth: '340px', display: 'block', margin: '0 auto' }}>
    <defs>
      <radialGradient id="b_glow" cx="50%" cy="60%" r="50%">
        <stop offset="0%" stopColor="#1DB954" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#1DB954" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="b_g1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1DB954" />
        <stop offset="100%" stopColor="#0d6e32" />
      </linearGradient>
      <linearGradient id="b_g2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2a2a2a" />
        <stop offset="100%" stopColor="#111" />
      </linearGradient>
      <linearGradient id="b_g3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1a3a5c" />
        <stop offset="100%" stopColor="#0d1f33" />
      </linearGradient>
      <filter id="b_blur"><feGaussianBlur stdDeviation="8"/></filter>
      <filter id="b_shadow"><feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000" floodOpacity="0.6"/></filter>
    </defs>
    {/* Glow fondo */}
    <ellipse cx="160" cy="180" rx="130" ry="60" fill="url(#b_glow)" />
    {/* Libro izquierdo — inclinado */}
    <g transform="rotate(-12, 80, 160)" filter="url(#b_shadow)">
      <rect x="30" y="80" width="80" height="110" rx="5" fill="url(#b_g2)" />
      <rect x="30" y="80" width="12" height="110" rx="5" fill="#a78bfa" />
      <rect x="52" y="105" width="46" height="3" rx="1.5" fill="#333" />
      <rect x="52" y="115" width="46" height="3" rx="1.5" fill="#333" />
      <rect x="52" y="125" width="30" height="3" rx="1.5" fill="#333" />
    </g>
    {/* Libro derecho — inclinado */}
    <g transform="rotate(10, 240, 155)" filter="url(#b_shadow)">
      <rect x="200" y="75" width="80" height="110" rx="5" fill="url(#b_g3)" />
      <rect x="200" y="75" width="12" height="110" rx="5" fill="#38bdf8" />
      <rect x="222" y="100" width="46" height="3" rx="1.5" fill="#1a3a5c" />
      <rect x="222" y="110" width="46" height="3" rx="1.5" fill="#1a3a5c" />
      <rect x="222" y="120" width="30" height="3" rx="1.5" fill="#1a3a5c" />
    </g>
    {/* Libro central — destacado */}
    <g filter="url(#b_shadow)">
      <rect x="110" y="45" width="100" height="140" rx="7" fill="url(#b_g2)" stroke="#1DB95433" strokeWidth="1.5" />
      <rect x="110" y="45" width="14" height="140" rx="7" fill="url(#b_g1)" />
      <rect x="136" y="80" width="60" height="4" rx="2" fill="#2a2a2a" />
      <rect x="136" y="92" width="60" height="4" rx="2" fill="#2a2a2a" />
      <rect x="136" y="104" width="40" height="4" rx="2" fill="#2a2a2a" />
      {/* Estrella central */}
      <circle cx="160" cy="145" r="16" fill="#1DB95418" stroke="#1DB95444" strokeWidth="1.5" />
      <text x="160" y="150" textAnchor="middle" fontSize="16" fill="#1DB954">★</text>
    </g>
    {/* Partículas flotantes */}
    <circle cx="55" cy="55" r="4" fill="#1DB954" opacity="0.5">
      <animate attributeName="cy" values="55;48;55" dur="3s" repeatCount="indefinite" />
    </circle>
    <circle cx="270" cy="50" r="3" fill="#a78bfa" opacity="0.4">
      <animate attributeName="cy" values="50;44;50" dur="2.5s" repeatCount="indefinite" />
    </circle>
    <circle cx="295" cy="130" r="5" fill="#1DB954" opacity="0.25">
      <animate attributeName="cy" values="130;122;130" dur="3.5s" repeatCount="indefinite" />
    </circle>
    <circle cx="25" cy="170" r="3" fill="#38bdf8" opacity="0.35">
      <animate attributeName="cy" values="170;163;170" dur="2.8s" repeatCount="indefinite" />
    </circle>
    <circle cx="160" cy="25" r="2.5" fill="#1DB954" opacity="0.6">
      <animate attributeName="cy" values="25;19;25" dur="2s" repeatCount="indefinite" />
    </circle>
  </svg>
);

// ── Ilustración 2: Salas de chat ─────────────────────────────────────────────
const IlusSalas = () => (
  <svg viewBox="0 0 320 240" style={{ width: '100%', maxWidth: '340px', display: 'block', margin: '0 auto' }}>
    <defs>
      <linearGradient id="s_g1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1DB954" />
        <stop offset="100%" stopColor="#15a044" />
      </linearGradient>
      <filter id="s_shadow"><feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.5"/></filter>
    </defs>
    {/* Portada libro */}
    <g filter="url(#s_shadow)">
      <rect x="20" y="30" width="70" height="95" rx="5" fill="#1a1a1a" stroke="#2a2a2a" strokeWidth="1" />
      <rect x="20" y="30" width="10" height="95" rx="4" fill="#1DB954" />
      <rect x="38" y="50" width="40" height="3" rx="1.5" fill="#2a2a2a" />
      <rect x="38" y="60" width="40" height="3" rx="1.5" fill="#2a2a2a" />
      <rect x="38" y="70" width="28" height="3" rx="1.5" fill="#2a2a2a" />
    </g>
    {/* Burbujas de chat */}
    {/* Burbuja izquierda 1 */}
    <g filter="url(#s_shadow)">
      <rect x="100" y="15" width="170" height="48" rx="16" rx2="4" fill="#1e1e1e" />
      <polygon points="100,40 85,52 112,50" fill="#1e1e1e" />
      <text x="116" y="34" fontSize="11" fill="#888" fontFamily="sans-serif">¿Qué os parece el giro</text>
      <text x="116" y="50" fontSize="11" fill="#888" fontFamily="sans-serif">del capítulo 12? 👀</text>
    </g>
    {/* Avatar izq */}
    <circle cx="76" cy="68" r="13" fill="#1a1a1a" stroke="#2a2a2a" strokeWidth="1" />
    <circle cx="76" cy="63" r="5" fill="#333" />
    <ellipse cx="76" cy="76" rx="7" ry="4" fill="#333" />
    {/* Burbuja derecha */}
    <g filter="url(#s_shadow)">
      <rect x="55" y="90" width="180" height="48" rx="16" fill="url(#s_g1)" />
      <polygon points="235,116 252,128 228,124" fill="#15a044" />
      <text x="72" y="109" fontSize="11" fill="#000" fontWeight="bold" fontFamily="sans-serif">¡Me lo vi venir desde</text>
      <text x="72" y="125" fontSize="11" fill="#000" fontWeight="bold" fontFamily="sans-serif">el capítulo 3! 🔥</text>
    </g>
    {/* Avatar der */}
    <circle cx="262" cy="140" r="13" fill="#1a1a1a" stroke="#1DB95444" strokeWidth="1.5" />
    <circle cx="262" cy="135" r="5" fill="#1DB95455" />
    <ellipse cx="262" cy="148" rx="7" ry="4" fill="#1DB95455" />
    {/* Burbuja izquierda 2 */}
    <g filter="url(#s_shadow)">
      <rect x="100" y="162" width="150" height="40" rx="16" fill="#1e1e1e" />
      <polygon points="100,182 85,194 112,192" fill="#1e1e1e" />
      <text x="116" y="178" fontSize="11" fill="#888" fontFamily="sans-serif">Spoiler! jajaja 😂</text>
      <text x="116" y="194" fontSize="11" fill="#888" fontFamily="sans-serif">Yo sigo en cap 8...</text>
    </g>
  </svg>
);

// ── Ilustración 3: Explorar y descubrir ──────────────────────────────────────
const IlusExplorar = () => (
  <svg viewBox="0 0 320 240" style={{ width: '100%', maxWidth: '340px', display: 'block', margin: '0 auto' }}>
    <defs>
      <linearGradient id="e_g1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1DB954" />
        <stop offset="100%" stopColor="#0d6e32" />
      </linearGradient>
      <filter id="e_shadow"><feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.5"/></filter>
    </defs>
    {/* Grid de libros — estilo biblioteca */}
    {[
      { x: 15, y: 30, color: '#1DB954', w: 58, h: 82 },
      { x: 83, y: 20, color: '#a78bfa', w: 58, h: 92 },
      { x: 151, y: 35, color: '#38bdf8', w: 58, h: 77 },
      { x: 219, y: 25, color: '#f59e0b', w: 58, h: 87 },
      { x: 15, y: 125, color: '#f472b6', w: 58, h: 80 },
      { x: 83, y: 120, color: '#34d399', w: 58, h: 85 },
      { x: 151, y: 128, color: '#fb923c', w: 58, h: 78 },
      { x: 219, y: 118, color: '#818cf8', w: 58, h: 88 },
    ].map((b, i) => (
      <g key={i} filter="url(#e_shadow)">
        <rect x={b.x} y={b.y} width={b.w} height={b.h} rx="5" fill="#141414" stroke="#1e1e1e" strokeWidth="1" />
        <rect x={b.x} y={b.y} width="9" height={b.h} rx="4" fill={b.color} opacity="0.9" />
        <rect x={b.x + 17} y={b.y + 18} width={b.w - 24} height="3" rx="1.5" fill="#2a2a2a" />
        <rect x={b.x + 17} y={b.y + 28} width={b.w - 30} height="3" rx="1.5" fill="#222" />
      </g>
    ))}
    {/* Lupa superpuesta */}
    <g filter="url(#e_shadow)">
      <circle cx="175" cy="118" r="38" fill="#000" fillOpacity="0.85" stroke="#1DB954" strokeWidth="2" />
      <circle cx="175" cy="118" r="28" fill="none" stroke="#1DB954" strokeWidth="2.5" />
      <line x1="196" y1="139" x2="210" y2="153" stroke="#1DB954" strokeWidth="3" strokeLinecap="round" />
      {/* Mini libro dentro de la lupa */}
      <rect x="160" y="106" width="30" height="22" rx="2" fill="#1DB95433" stroke="#1DB954" strokeWidth="1" />
      <rect x="160" y="106" width="5" height="22" rx="2" fill="#1DB954" />
      <text x="175" y="121" textAnchor="middle" fontSize="10" fill="#1DB954">✦</text>
    </g>
  </svg>
);

// ── Ilustración 4: Clubs privados ────────────────────────────────────────────
const IlusClubs = () => (
  <svg viewBox="0 0 320 240" style={{ width: '100%', maxWidth: '340px', display: 'block', margin: '0 auto' }}>
    <defs>
      <radialGradient id="c_glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#a78bfa" stopOpacity="0.15" />
        <stop offset="100%" stopColor="#a78bfa" stopOpacity="0" />
      </radialGradient>
      <filter id="c_shadow"><feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.5"/></filter>
    </defs>
    <ellipse cx="160" cy="140" rx="120" ry="55" fill="url(#c_glow)" />
    {/* Avatares en círculo */}
    {[
      { cx: 160, cy: 60, color: '#1DB954', label: 'A' },
      { cx: 240, cy: 110, color: '#a78bfa', label: 'B' },
      { cx: 220, cy: 195, color: '#38bdf8', label: 'C' },
      { cx: 100, cy: 195, color: '#f59e0b', label: 'D' },
      { cx: 80, cy: 110, color: '#f472b6', label: 'E' },
    ].map((a, i) => (
      <g key={i} filter="url(#c_shadow)">
        <circle cx={a.cx} cy={a.cy} r="24" fill="#141414" stroke={a.color} strokeWidth="2" />
        <circle cx={a.cx} cy={a.cy - 6} r="9" fill={a.color} opacity="0.3" />
        <ellipse cx={a.cx} cy={a.cy + 14} rx="13" ry="8" fill={a.color} opacity="0.3" />
        {/* Línea al centro */}
        <line x1={a.cx} y1={a.cy} x2="160" y2="128"
          stroke={a.color} strokeWidth="1" strokeOpacity="0.25" strokeDasharray="4 3" />
      </g>
    ))}
    {/* Libro central */}
    <g filter="url(#c_shadow)">
      <rect x="138" y="104" width="44" height="60" rx="5" fill="#1a1a1a" stroke="#a78bfa44" strokeWidth="1.5" />
      <rect x="138" y="104" width="8" height="60" rx="4" fill="#a78bfa" />
      <text x="160" y="140" textAnchor="middle" fontSize="18" fill="#a78bfa">♛</text>
    </g>
  </svg>
);

// ── Ilustración 5: Reto lector ────────────────────────────────────────────────
const IlusReto = () => (
  <svg viewBox="0 0 320 240" style={{ width: '100%', maxWidth: '340px', display: 'block', margin: '0 auto' }}>
    <defs>
      <linearGradient id="r_g1" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#1DB954" />
        <stop offset="100%" stopColor="#FFD700" />
      </linearGradient>
      <filter id="r_shadow"><feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.5"/></filter>
      <filter id="r_glow"><feGaussianBlur stdDeviation="3" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
    </defs>
    {/* Trofeo */}
    <g filter="url(#r_shadow)">
      <rect x="130" y="165" width="60" height="12" rx="6" fill="#2a2a2a" />
      <rect x="148" y="148" width="24" height="20" rx="2" fill="#1e1e1e" />
      <path d="M110 60 Q110 30 160 25 Q210 30 210 60 L200 130 Q190 148 160 148 Q130 148 120 130 Z" fill="#1a1a1a" stroke="#FFD70044" strokeWidth="1.5" />
      <path d="M110 70 Q85 70 80 95 Q75 120 110 125" fill="none" stroke="#2a2a2a" strokeWidth="8" strokeLinecap="round" />
      <path d="M210 70 Q235 70 240 95 Q245 120 210 125" fill="none" stroke="#2a2a2a" strokeWidth="8" strokeLinecap="round" />
      <text x="160" y="115" textAnchor="middle" fontSize="40" fill="#FFD700" filter="url(#r_glow)">★</text>
    </g>
    {/* Barra de progreso */}
    <rect x="40" y="195" width="240" height="12" rx="6" fill="#1a1a1a" />
    <rect x="40" y="195" width="192" height="12" rx="6" fill="url(#r_g1)" />
    <text x="40" y="222" fontSize="11" fill="#555" fontFamily="sans-serif">0</text>
    <text x="272" y="222" fontSize="11" fill="#555" fontFamily="sans-serif" textAnchor="end">24 libros</text>
    <text x="232" y="210" fontSize="11" fill="#FFD700" fontFamily="sans-serif" fontWeight="bold">16/24</text>
    {/* Partículas doradas */}
    <circle cx="80" cy="50" r="3" fill="#FFD700" opacity="0.5"><animate attributeName="opacity" values="0.5;0.1;0.5" dur="2s" repeatCount="indefinite"/></circle>
    <circle cx="250" cy="45" r="2" fill="#1DB954" opacity="0.4"><animate attributeName="opacity" values="0.4;0.1;0.4" dur="2.5s" repeatCount="indefinite"/></circle>
    <circle cx="290" cy="100" r="3" fill="#FFD700" opacity="0.3"><animate attributeName="opacity" values="0.3;0.1;0.3" dur="1.8s" repeatCount="indefinite"/></circle>
  </svg>
);

// ── Pasos del onboarding ──────────────────────────────────────────────────────
const PASOS = [
  {
    id: 'bienvenida',
    ilustracion: <IlusBienvenida />,
    titulo: 'Bienvenido a Leemos',
    subtitulo: 'Tu comunidad de lectura. Descubre libros, debate con otros lectores y lleva el control de lo que lees.',
    boton: 'Empezar',
    color: '#1DB954',
  },
  {
    id: 'salas',
    ilustracion: <IlusSalas />,
    titulo: 'Debate en tiempo real',
    subtitulo: 'Cada libro tiene su sala de chat. Entra, comparte tu opinión, descubre perspectivas que no habías visto.',
    boton: 'Siguiente',
    color: '#1DB954',
  },
  {
    id: 'explorar',
    ilustracion: <IlusExplorar />,
    titulo: 'Explora y descubre',
    subtitulo: 'Encuentra tu próxima lectura por género, tendencias o lo que están leyendo otros lectores ahora mismo.',
    boton: 'Siguiente',
    color: '#38bdf8',
  },
  {
    id: 'clubs',
    ilustracion: <IlusClubs />,
    titulo: 'Clubs de lectura',
    subtitulo: 'Crea o únete a clubs privados. Elegid el libro del mes juntos, debatid y construid vuestra comunidad.',
    boton: 'Siguiente',
    color: '#a78bfa',
  },
  {
    id: 'reto',
    ilustracion: <IlusReto />,
    titulo: 'Reto lector anual',
    subtitulo: 'Ponte un objetivo de libros para el año y supéralo. Cada libro leído te acerca al trofeo.',
    boton: 'Siguiente',
    color: '#FFD700',
  },
  {
    id: 'generos',
    ilustracion: null,
    titulo: '¿Qué te gusta leer?',
    subtitulo: 'Elige tus géneros favoritos. Usaremos esto para personalizar tu experiencia.',
    boton: 'Entrar a Leemos',
    color: '#1DB954',
    esGeneros: true,
  },
];

// ── Componente principal ──────────────────────────────────────────────────────
export function Onboarding({ userId, onCompletado }) {
  const [paso, setPaso] = useState(0);
  const [generosElegidos, setGenerosElegidos] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [animando, setAnimando] = useState(false);
  const pasoActual = PASOS[paso];

  const toggleGenero = (g) => {
    setGenerosElegidos(prev =>
      prev.includes(g) ? prev.filter(x => x !== g) : [...prev, g]
    );
  };

  const irPaso = (nuevo) => {
    setAnimando(true);
    setTimeout(() => {
      setPaso(nuevo);
      setAnimando(false);
    }, 220);
  };

  const siguiente = async () => {
    if (paso < PASOS.length - 1) {
      irPaso(paso + 1);
      return;
    }
    setGuardando(true);
    try {
      try {
        await updateDoc(doc(db, 'users', userId), {
          generos: generosElegidos,
          onboardingCompletado: true,
        });
      } catch {
        await setDoc(doc(db, 'users', userId), {
          generos: generosElegidos,
          onboardingCompletado: true,
        }, { merge: true }).catch(() => {});
      }
    } catch (e) { console.error(e); }
    setGuardando(false);
    onCompletado(generosElegidos);
  };

  const isMobile = window.innerWidth < 768;
  const colorActual = pasoActual.color || '#1DB954';

  return (
    <div style={{
      position: 'fixed', inset: 0, background: '#000', zIndex: 9999,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'space-between',
      padding: isMobile ? '36px 24px 44px' : '56px 40px',
      fontFamily: 'sans-serif', color: 'white',
      overflow: 'hidden',
    }}>
      {/* Fondo dinámico con color del paso */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 0,
        background: `radial-gradient(ellipse at 50% 100%, ${colorActual}0d 0%, transparent 70%)`,
        transition: 'background 0.6s ease',
        pointerEvents: 'none',
      }} />

      {/* Indicadores de progreso */}
      <div style={{ display: 'flex', gap: '6px', alignSelf: 'center', zIndex: 1 }}>
        {PASOS.map((p, i) => (
          <div key={i} onClick={() => i < paso && irPaso(i)} style={{
            width: i === paso ? '28px' : '7px',
            height: '7px',
            borderRadius: '4px',
            background: i === paso ? colorActual : i < paso ? `${colorActual}55` : '#1e1e1e',
            transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: i < paso ? 'pointer' : 'default',
          }} />
        ))}
      </div>

      {/* Contenido */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', width: '100%', maxWidth: '440px', gap: '24px',
        zIndex: 1,
        opacity: animando ? 0 : 1,
        transform: animando ? 'translateY(12px)' : 'translateY(0)',
        transition: 'opacity 0.22s ease, transform 0.22s ease',
      }}>

        {/* Ilustración */}
        {pasoActual.ilustracion && (
          <div style={{ width: '100%' }}>
            {pasoActual.ilustracion}
          </div>
        )}

        {/* Texto */}
        <div style={{ textAlign: 'center', padding: '0 8px' }}>
          <div style={{
            display: 'inline-block',
            background: `${colorActual}18`,
            border: `1px solid ${colorActual}33`,
            borderRadius: '20px',
            padding: '4px 14px',
            fontSize: '11px',
            fontWeight: 'bold',
            color: colorActual,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            marginBottom: '14px',
          }}>
            {paso + 1} / {PASOS.length}
          </div>
          <h1 style={{
            fontSize: isMobile ? '26px' : '32px',
            fontWeight: 900,
            margin: '0 0 12px',
            lineHeight: '1.2',
            letterSpacing: '-0.5px',
          }}>
            {pasoActual.titulo}
          </h1>
          <p style={{
            color: '#666',
            fontSize: isMobile ? '14px' : '15px',
            lineHeight: '1.65',
            margin: 0,
          }}>
            {pasoActual.subtitulo}
          </p>
        </div>

        {/* Selector de géneros */}
        {pasoActual.esGeneros && (
          <div style={{ width: '100%', maxHeight: '240px', overflowY: 'auto' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', paddingBottom: '4px' }}>
              {GENEROS_LIBROS.map(g => {
                const activo = generosElegidos.includes(g);
                return (
                  <button key={g} onClick={() => toggleGenero(g)} style={{
                    background: activo ? colorActual : '#111',
                    color: activo ? 'black' : '#666',
                    border: `1px solid ${activo ? colorActual : '#222'}`,
                    borderRadius: '20px',
                    padding: '8px 16px',
                    fontWeight: activo ? 'bold' : 'normal',
                    cursor: 'pointer',
                    fontSize: '13px',
                    transition: 'all 0.18s ease',
                    WebkitTapHighlightColor: 'transparent',
                  }}>
                    {g}
                  </button>
                );
              })}
            </div>
            {generosElegidos.length > 0 && (
              <p style={{ textAlign: 'center', color: colorActual, fontSize: '12px', margin: '10px 0 0', fontWeight: 'bold' }}>
                {generosElegidos.length} {generosElegidos.length === 1 ? 'género elegido' : 'géneros elegidos'}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Botones */}
      <div style={{ width: '100%', maxWidth: '440px', zIndex: 1, paddingBottom: paso === PASOS.length - 1 ? '72px' : '0' }}>
        <button onClick={siguiente} disabled={guardando} style={{
          width: '100%',
          background: pasoActual.esGeneros && generosElegidos.length === 0
            ? '#111' : colorActual,
          color: pasoActual.esGeneros && generosElegidos.length === 0
            ? '#333' : colorActual === '#FFD700' ? '#000' : 'black',
          border: `1px solid ${pasoActual.esGeneros && generosElegidos.length === 0 ? '#222' : colorActual}`,
          borderRadius: '30px',
          padding: '16px',
          fontWeight: 900,
          fontSize: '15px',
          cursor: guardando ? 'default' : 'pointer',
          transition: 'all 0.2s ease',
          letterSpacing: '0.3px',
          WebkitTapHighlightColor: 'transparent',
        }}>
          {guardando ? 'Guardando...' : pasoActual.boton}
        </button>

        {paso < PASOS.length - 1 && (
          <button onClick={() => irPaso(PASOS.length - 1)} style={{
            width: '100%', background: 'none', border: 'none',
            color: '#2a2a2a', fontSize: '13px', cursor: 'pointer',
            marginTop: '14px', padding: '8px',
            WebkitTapHighlightColor: 'transparent',
            transition: 'color 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.color = '#444'}
            onMouseLeave={e => e.currentTarget.style.color = '#2a2a2a'}>
            Saltar
          </button>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
